import React from 'react';
import { Check, X } from 'lucide-react';
import { ContentSection } from '../ui/ContentSection';
export function TargetAudience() {
  return <ContentSection background="gray" id="target" data-id="element-157">
      <div className="text-center mb-16" data-id="element-158">
        <span className="text-amber-600 font-bold tracking-wider text-sm uppercase mb-4 block" data-id="element-159">
          PARA QUIÉN ES / PARA QUIÉN NO
        </span>
        <h2 className="text-3xl md:text-5xl font-bold text-[#1A1A1A]" data-id="element-160">
          ¿Este libro es para ti?
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-161">
        {/* YES Column */}
        <div className="bg-white p-8 rounded-2xl shadow-sm border border-green-100" data-id="element-162">
          <div className="flex items-center gap-3 mb-6" data-id="element-163">
            <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center text-green-600" data-id="element-164">
              <Check className="w-6 h-6" data-id="element-165" />
            </div>
            <h3 className="text-xl font-bold text-gray-900" data-id="element-166">
              Sí, es para ti si:
            </h3>
          </div>
          <ul className="space-y-4" data-id="element-167">
            {['Trabajas en ventas, emprendimiento o lideras tu ingreso', 'Ya tienes resultados, pero sientes desorden interno', "Terminas el día pensando: 'hice demasiado… y aun así faltó'", 'Quieres crecer sin sacrificar tu salud, familia o paz', 'Sabes que tu problema no es disciplina, es enfoque'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-700" data-id="element-168">
                <Check className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" data-id="element-169" />
                <span data-id="element-170">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* NO Column */}
        <div className="bg-white p-8 rounded-2xl shadow-sm border border-red-100" data-id="element-171">
          <div className="flex items-center gap-3 mb-6" data-id="element-172">
            <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center text-red-600" data-id="element-173">
              <X className="w-6 h-6" data-id="element-174" />
            </div>
            <h3 className="text-xl font-bold text-gray-900" data-id="element-175">
              No es para ti si:
            </h3>
          </div>
          <ul className="space-y-4 mb-6" data-id="element-176">
            {['Buscas frases bonitas para motivarte', 'Quieres un truco rápido sin mirarte con honestidad', 'No estás dispuesta a tomar decisiones incómodas', 'Prefieres la queja a la responsabilidad', 'Crees que trabajar más horas es la única solución'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-700" data-id="element-177">
                <X className="w-5 h-5 text-red-500 mt-1 flex-shrink-0" data-id="element-178" />
                <span data-id="element-179">{item}</span>
              </li>)}
          </ul>
          <div className="pt-6 border-t border-gray-100" data-id="element-180">
            <p className="text-gray-600 leading-relaxed" data-id="element-181">
              Si hoy no estás lista para mirarte con honestidad, este no es tu
              momento.
            </p>
            <p className="text-gray-500 mt-2 italic" data-id="element-182">Y está bien.</p>
          </div>
        </div>
      </div>
    </ContentSection>;
}